export var PaymentFormText;
(function (PaymentFormText) {
    PaymentFormText["FAILED_GIFTCARD_FETCH"] = "Failed to fetch gift card.";
    PaymentFormText["ONE_GIFTCARD_ERROR"] = "Only one gift card can be used per payment. Please clear your selections first.";
    PaymentFormText["GIFTCARD_NOT_FOUND"] = "Gift card not found.";
    PaymentFormText["GIFTCARD_ADDED"] = "Gift card successfully added.";
    PaymentFormText["GIFTCARD"] = "Gift Card";
    PaymentFormText["CREDITCARD"] = "Credit Card";
    PaymentFormText["SELECT_PAYMENT_OPTION"] = "Select payment options";
    PaymentFormText["GIFT_CARD_NUMBER_REQUIRED"] = "Please enter a gift card number";
    PaymentFormText["ADD_CREDIT_CARD"] = "Add Credit Card";
})(PaymentFormText || (PaymentFormText = {}));
